var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0h-13A1.5 1.5 0 000 1.5v10A1.5 1.5 0 001.5 13H4v3.248a.75.75 0 001.255.555L9.425 13H14.5a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0014.5 0z",
    fill: "#000"
  })));
}

export default "data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14.5 0H1.5C0.671 0 0 0.672 0 1.5V11.5C0 12.328 0.671 13 1.5 13H4V16.248C4 16.9 4.774 17.242 5.255 16.803L9.425 13H9.694H14.5C15.329 13 16 12.328 16 11.5V1.5C16 0.672 15.329 0 14.5 0Z' fill='black'/%3E %3C/svg%3E";
export { SvgChat as ReactComponent };